import Divider from '@mui/material/Divider';
import { Avatar, Card, CardActions, CardContent, Skeleton, Typography } from '@mui/material';
import { IDetailsCard } from './types';
import Theme from '../../Themes/main.theme';
import ConditionalWrapper from '../ConditionalWrapper/ConditionalWrapper';

const DetailsCard = (props: IDetailsCard) => {
  const { actionButtons, icon, title, subtitle, children, isLoading, picture } = props;
  const skeletonLoader = <Skeleton width='50%'/>;
  return (
    <>
      <Card sx={{ minWidth: 275 }} elevation={5}>
        <CardContent sx={{mt: '50px'}}>
          <CardActions sx={{display: 'flex', justifyContent: 'flex-end'}}>
            {!isLoading && actionButtons}
          </CardActions>
          <Divider sx={{mt: '-35px'}}>
            <ConditionalWrapper condition={isLoading} 
              wrapper={(children) => <Skeleton variant='circular'>{children}</Skeleton>}>
              <Avatar sx={{ width: 70, height: 70, bgcolor: picture
                ? 'inherit'
                : Theme?.ekomeColor?.main }}>
                {icon}
              </Avatar>
            </ConditionalWrapper> 
          </Divider>
          <Typography color={Theme?.labelColor?.main} variant='h3'
            sx={{display: 'flex', justifyContent: 'center', mt: 4, mb: 2}}>
            {isLoading 
              ? skeletonLoader
              : title && title}
          </Typography>
          {subtitle
            ?<Typography color={Theme?.labelColor?.main}
              sx={{display: 'flex', justifyContent: 'center'}}>
              {subtitle}
            </Typography>
            : null
          }

          {children}
        
        </CardContent>
      </Card>
    </>
  );
};

export default DetailsCard;
